(() => {
  const SELECTORS = {
    container: '#ProductGridContainer',
    list: '#product-grid',
    button: '[data-shop-load-more]',
  };

  function getSectionId() {
    const list = document.querySelector(SELECTORS.list);
    return list?.dataset?.id || null;
  }

  function getNextUrl(button) {
    return button?.getAttribute('data-next-url') || '';
  }

  function setNextUrl(button, url) {
    if (!button) return;
    if (url) button.setAttribute('data-next-url', url);
    else button.removeAttribute('data-next-url');
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.toggleAttribute('disabled', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  async function fetchNextPage(sectionId, nextUrl) {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(`Load more failed: ${res.status}`);
    const htmlText = await res.text();
    return new DOMParser().parseFromString(htmlText, 'text/html');
  }

  function extractNextUrl(doc) {
    // When we render a section via ?section_id=..., Shopify returns just the section HTML,
    // but we can still query within it.
    const btn = doc.querySelector(SELECTORS.button);
    return getNextUrl(btn);
  }

  function extractItems(doc) {
    const list = doc.querySelector(SELECTORS.list);
    if (!list) return [];
    return Array.from(list.querySelectorAll('li.grid__item'));
  }

  async function onClick(e) {
    const button = e.currentTarget;
    const sectionId = getSectionId();
    const nextUrl = getNextUrl(button);

    if (!sectionId || !nextUrl) return;

    try {
      setLoading(button, true);
      const doc = await fetchNextPage(sectionId, nextUrl);
      const items = extractItems(doc);
      const list = document.querySelector(SELECTORS.list);
      if (!list || items.length === 0) {
        setNextUrl(button, '');
        button.closest('.shop-load-more')?.remove();
        return;
      }

      items.forEach((item) => list.appendChild(item));

      const newNextUrl = extractNextUrl(doc);
      if (newNextUrl) {
        setNextUrl(button, newNextUrl);
      } else {
        button.closest('.shop-load-more')?.remove();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setLoading(button, false);
    }
  }

  function bind(root = document) {
    const button = root.querySelector(SELECTORS.button);
    if (!button) return;
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', onClick);
  }

  function init() {
    bind(document);

    const container = document.querySelector(SELECTORS.container);
    if (!container) return;

    // Facets filtering replaces #ProductGridContainer innerHTML; re-bind when it changes.
    const observer = new MutationObserver(() => bind(container));
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


